import { createStore , mutatorAction } from "satcheljs";

import { SchedulingConstraintsPanelActions } from "./SchedulingConstraintsPanelActions";
import { SchedulingConstraintsPanelState } from "./SchedulingConstraintsPanelState";

const initialState: SchedulingConstraintsPanelState = {
    isPanelOpen: false
};

const schedulingConstraintsPanelStore = createStore(
    'schedulingConstraintsPanelStore',
    initialState
);

const openPanel = mutatorAction("openPanel", function openPanel() {
    schedulingConstraintsPanelStore().isPanelOpen = true;
});

const closePanel = mutatorAction("closePanel", function closePanel() {
    schedulingConstraintsPanelStore().isPanelOpen = false;
});

/**
 * The store which holds the scheduling constraints panel state.
 */
export const SchedulingConstraintsPanelStore = schedulingConstraintsPanelStore;

/**
 * The actions for the scheduling constraints panel store.
 */
export const schedulingConstraintsPanelActions: SchedulingConstraintsPanelActions = {
    openPanel,
    closePanel
};